import { makeRequest, SADUKA_TRANSPORT_PREFIX } from "../utils/apiUtils";

export const GET_LIST = "currency/GET_LIST";
export const GET_LIST_SUCCESS = "currency/GET_LIST_SUCCESS";
export const GET_LIST_FAIL = "currency/GET_LIST_FAIL";

export function getList() {
  return makeRequest(`${SADUKA_TRANSPORT_PREFIX}/currencies`, {
    types: [GET_LIST, GET_LIST_SUCCESS, GET_LIST_FAIL],
    options: {
      credentials: 'include'
    },
  });
}
